import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  label: {
    maxWidth: '100%',
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '16px',
    color: 'rgba(0, 0, 0, 0.54)',
    marginBottom: 10,
    '&:not(:first-child)': {
      marginTop: 10,
    },
  },
  list: {
    width: ({ provider }) => (provider ? 'auto' : 450),
    maxWidth: '100%',
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
}));
